export function reportQueryErrorMessage(err, fallback) {
  const data = err && err.response && err.response.data;
  if (data) {
    return data.detail || data.message || fallback;
  }
  return (err && err.message) || fallback;
}
